/**
 * 接口路径常量 —— 前端与后端共用，禁止在业务代码里手写字符串。
 * 命名对齐对标产品，便于对照 research/reports/api-contract.json。
 */
export const AUTH = {
    sendCode: '/v2/api/auth/send_code',
    login: '/v2/api/auth/login',
    checkStatus: '/v2/api/auth/check_account_status',
    logout: '/v2/api/auth/logout',
};
export const PROFILE = {
    list: '/v2/api/profile/profiles',
    detail: (id) => `/v2/api/profile/profiles/${id}`,
    industryTree: '/v2/api/profile/industries/tree',
    topics: (id) => `/v2/api/profile/profiles/${id}/topics`,
    submit: '/v2/api/profile/submit',
    uploadImage: '/v2/api/profile/upload/image',
    complianceReview: '/v2/api/profile/compliance/review',
    videoCopyExtract: '/v2/api/profile/video-copy/extract',
};
export const COPYWRITING = {
    archives: '/v2/api/industry-copywriting/archives',
    proposalPreview: '/v2/api/industry-copywriting/proposals/preview',
    generate: '/v2/api/industry-copywriting/archives/copy',
    rewriteByBenchmark: '/v2/api/industry-copywriting/archives/copy/rewrite-v3/by-benchmark',
    tikSearch: '/v2/api/industry-copywriting/archives/copy/tiksearch',
    styleGenerate: '/v2/api/industry-copywriting/archives/copy/tiksearch/style-generate',
    ruleCheck: '/v2/api/copywriting/legal-review-v2/rule-check',
    llmStatus: '/v2/api/copywriting/llm-status',
};
export const TTS = {
    voices: '/v2/api/tts/voices',
    uploadVoice: '/v2/api/tts/voices/upload',
    deleteVoice: (id) => `/v2/api/tts/voices/${id}`,
    emotions: '/v2/api/tts/emotions',
    /** 任务式配音（线上当前版本使用；比 v3 的 SSE 更简单） */
    submit: '/v2/api/tts/submit',
    task: (id) => `/v2/api/tts/tasks/${encodeURIComponent(id)}`,
    /** 旧的分段 SSE 方案，保留常量便于兼容 */
    synthesize: '/v3/api/tts',
    jobEvents: (jobId) => `/v3/api/tts/jobs/${encodeURIComponent(jobId)}/events`,
};
export const DIGITAL_HUMAN = {
    modelList: '/v2/api/digital-human/model/list',
    trainSubmit: '/v2/api/digital-human/train/submit',
    trainTasks: '/v2/api/digital-human/train/tasks',
    trainQuota: '/v2/api/digital-human/train/quota',
    generateSubmit: '/v2/api/digital-human/generation/submit',
    generateTask: (id) => `/v2/api/digital-human/generation/task/${id}`,
    imageSubmitUrl: '/v2/api/image-to-talk/talking-head/submit-url',
    imageTasks: '/v2/api/image-to-talk/tasks',
    /** 训练额度 */
    quota: '/v2/api/digital-human/train/quota',
};
export const EDITING = {
    templates: '/api/local-gateway/hyperframes/templates',
    tasks: '/api/local-gateway/hyperframes/tasks',
    task: (id) => `/api/local-gateway/hyperframes/tasks/${id}`,
    project: (id) => `/api/local-gateway/hyperframes/tasks/${id}/project`,
    /** 字幕风格（特效字幕） */
    subtitleStyles: '/v2/api/effect-packaging-v2/subtitle-styles',
    subtitleSubmit: '/v2/api/effect-packaging-v2/tasks',
    firstFrame: '/v2/api/video-processing/video/first-frame',
    bgmList: '/v2/api/video-processing/bgm/list',
    bgmAdd: '/v2/api/video-processing/bgm/add',
    bgmStatus: (id) => `/v2/api/video-processing/bgm/status/${id}`,
};
export const COVER = {
    templates: '/v2/api/thumbnail/cover-prompt-templates/new',
    optimize: '/v2/api/thumbnail/optimize/gpt-model',
    custom: '/v2/api/thumbnail/custom',
};
export const POINTS = {
    account: '/v2/api/auth/me/points-account',
    ledger: '/v2/api/auth/me/points-ledger',
    pricingRules: '/v2/api/auth/me/points-pricing-rules',
};
/** 发布（P0 记录到本地，P2 再接真实渠道） */
export const PUBLISH = {
    submit: '/v2/api/publish',
    list: '/v2/api/publish/list',
};
//# sourceMappingURL=api.js.map